import { render, staticRenderFns } from "./LayoutUser.vue?vue&type=template&id=9f2c1764&scoped=true"
import script from "./LayoutUser.vue?vue&type=script&lang=js"
export * from "./LayoutUser.vue?vue&type=script&lang=js"
import style0 from "./LayoutUser.vue?vue&type=style&index=0&id=9f2c1764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2c1764",
  null
  
)

export default component.exports